import React, { useState, Children } from 'react';
import { motion } from 'framer-motion';
import { Sidebar } from './components/Sidebar';
import { MetricCards } from './components/MetricCards';
import { ShowSchedule } from './components/ShowSchedule';
import { SeatMap } from './components/SeatMap';
import { RevenueChart } from './components/RevenueChart';
import { TopFilmsTable } from './components/TopFilmsTable';
import { AIInsightCard } from './components/AIInsightCard';
import { DashboardToolbar } from './components/DashboardToolbar';
import { AskAI } from './components/AskAI';
import { ScreenConfig } from './pages/ScreenConfig';
import { ShowtimeManagement } from './pages/ShowtimeManagement';
import { SeatOccupancy } from './pages/SeatOccupancy';
import { FBOperations } from './pages/FBOperations';
import { useThemeColor } from './hooks/useThemeColor';
const pageVariants = {
  hidden: {
    opacity: 0
  },
  show: {
    opacity: 1,
    transition: {
      staggerChildren: 0.15
    }
  }
};
const sectionVariants = {
  hidden: {
    opacity: 0,
    y: 20
  },
  show: {
    opacity: 1,
    y: 0,
    transition: {
      duration: 0.6,
      ease: [0.16, 1, 0.3, 1]
    }
  }
};
export function App() {
  const [activeTab, setActiveTab] = useState('overview');
  const [sidebarCollapsed, setSidebarCollapsed] = useState(false);
  const [dateRange, setDateRange] = useState('1d');
  const {
    themeColor,
    setThemeColor
  } = useThemeColor();
  const getSubtitle = () => {
    switch (dateRange) {
      case '1d':
        return "Today's theatre performance metrics";
      case '7d':
        return "Week's theatre performance metrics";
      case '1m':
        return "Month's theatre performance metrics";
      case '3m':
        return '3 months theatre performance metrics';
      case '1y':
        return "Year's theatre performance metrics";
      case 'custom':
        return 'Custom range theatre performance metrics';
      default:
        return "Today's theatre performance metrics";
    }
  };
  const handleAddWidget = () => {
    alert('Add widget functionality will be implemented here.');
  };
  return <div className="min-h-screen bg-[#F7F7F7] flex" data-id="element-0">
      <Sidebar activeTab={activeTab} setActiveTab={setActiveTab} themeColor={themeColor} setThemeColor={setThemeColor} collapsed={sidebarCollapsed} onToggleCollapse={() => setSidebarCollapsed(!sidebarCollapsed)} data-id="element-1" />

      <main className={`flex-1 pt-14 md:pt-0 pb-20 md:pb-0 overflow-x-hidden transition-all duration-300 ease-in-out ${sidebarCollapsed ? 'md:ml-16' : 'md:ml-64'}`} data-id="element-2">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-8" data-id="element-3">
          {activeTab === 'overview' && <>
              <header className="mb-6" data-id="element-4">
                <h1 className="text-2xl font-bold text-gray-900 tracking-tight" data-id="element-5">
                  Overview
                </h1>
                <p className="text-sm text-gray-500 mt-1 transition-all duration-300" data-id="element-6">
                  {getSubtitle()}
                </p>
              </header>

              <AskAI data-id="element-7" />

              <DashboardToolbar dateRange={dateRange} onDateRangeChange={setDateRange} onAddWidget={handleAddWidget} data-id="element-8" />

              <motion.div variants={pageVariants} initial="hidden" animate="show" className="space-y-8" data-id="element-9">
                <MetricCards data-id="element-10" />

                <motion.div variants={sectionVariants} data-id="element-11">
                  <ShowSchedule data-id="element-12" />
                </motion.div>

                <div className="grid grid-cols-1 lg:grid-cols-3 gap-8" data-id="element-13">
                  <motion.div variants={sectionVariants} className="lg:col-span-2" data-id="element-14">
                    <RevenueChart data-id="element-15" />
                  </motion.div>
                  <motion.div variants={sectionVariants} className="lg:col-span-1 h-[400px] lg:h-auto" data-id="element-16">
                    <SeatMap data-id="element-17" />
                  </motion.div>
                </div>

                <motion.div variants={sectionVariants} data-id="element-18">
                  <TopFilmsTable data-id="element-19" />
                </motion.div>

                <motion.div variants={sectionVariants} data-id="element-20">
                  <AIInsightCard data-id="element-21" />
                </motion.div>
              </motion.div>
            </>}

          {activeTab === 'screens' && <>
              <header className="mb-6" data-id="element-22">
                <h1 className="text-2xl font-bold text-gray-900 tracking-tight" data-id="element-23">
                  Screen & Seat Configuration
                </h1>
                <p className="text-sm text-gray-500 mt-1" data-id="element-24">
                  Manage physical theatre layouts and seating categories
                </p>
              </header>
              <ScreenConfig data-id="element-25" />
            </>}

          {activeTab === 'shows' && <>
              <header className="mb-6" data-id="element-26">
                <h1 className="text-2xl font-bold text-gray-900 tracking-tight" data-id="element-27">
                  Showtime Management
                </h1>
                <p className="text-sm text-gray-500 mt-1" data-id="element-28">
                  Schedule, edit, and bulk import daily showtimes
                </p>
              </header>
              <ShowtimeManagement data-id="element-29" />
            </>}

          {activeTab === 'occupancy' && <>
              <header className="mb-6" data-id="element-30">
                <h1 className="text-2xl font-bold text-gray-900 tracking-tight" data-id="element-31">
                  Seat Occupancy
                </h1>
                <p className="text-sm text-gray-500 mt-1" data-id="element-32">
                  Real-time occupancy across all screens and showtimes
                </p>
              </header>
              <SeatOccupancy data-id="element-33" />
            </>}

          {activeTab === 'fb' && <FBOperations data-id="element-34" />}
        </div>
      </main>
    </div>;
}